export default "__VITE_ASSET__CweFhq7F__"